module.exports = __webpack_public_path__ + "img/32.8534819c.png";